/**
 * The survey question editor's limits — plan-030 OD-9 (the owner accepted the defaults, 2026-10-28), design §41.6.1
 * step 2 and §41.3.2.
 *
 * Product values, named here once: long enough for a real survey, short enough for a telephone conversation and a fast
 * save. They are not configuration (nothing reads them from the environment) and never vary by account. Every reader —
 * `surveyQuestionnaireEditOf`, the api's body bound, the portal's counters — takes them from this module.
 */
/** Questions in one group (`variants.A` / `variants.B`). Refused past it: `question_limit_exceeded`. */
export const SURVEY_QUESTION_LIMIT = 50;
/** Options of one choice question. Refused past it: `option_limit_exceeded`. */
export const SURVEY_OPTION_LIMIT = 12;
/** Characters of a question's own spoken text (its wording, clarification, scale words, options, follow-up). */
export const SURVEY_TEXT_LIMIT = 400;
/** Skip rules in one group (Release 2, `skip_rules`). Refused past it: `rule_limit_exceeded`. */
export const SURVEY_SKIP_RULE_LIMIT = 30;
/** Mandatory lines in one group (Release 2, `mandatory_lines`). Refused past it: `mandatory_line_limit_exceeded`. */
export const SURVEY_MANDATORY_LINE_LIMIT = 10;
/** Characters of one mandatory line (Release 2): 1 to this, spoken exactly. */
export const SURVEY_MANDATORY_LINE_TEXT_LIMIT = 400;
/** Forbidden phrases of one questionnaire (Release 2). Refused past it: `forbidden_phrase_limit_exceeded`. */
export const SURVEY_FORBIDDEN_PHRASE_LIMIT = 20;
/** Characters of one forbidden phrase (Release 2), after trimming: at least the first, at most the second. */
export const SURVEY_FORBIDDEN_PHRASE_LENGTH = Object.freeze({ least: 2, most: 80 });
/** Characters of a save's optional change note (design §41.5). */
export const SURVEY_CHANGE_NOTE_LIMIT = 200;
//# sourceMappingURL=survey-limit.js.map